'use client';

import React, { useEffect } from 'react';
import { Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import clsx from 'clsx';
import Image from 'next/image';

import fullSize from 'assets/fullSizeIcon.png';
import { addCanalPlusGTMClass, prepareImagePath } from 'services/lib/util';
import { RectangleArrow } from '../../icons/rectangle-arrow';

import 'photoswipe/style.css';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const ACFPostGallery = ({ data }) => {
  useEffect(() => {
    let lightbox = new PhotoSwipeLightbox({
      gallery: '#photoGallery',
      children: 'a',
      pswpModule: () => import('photoswipe'),
    });
    lightbox.init();

    return () => {
      lightbox.destroy();
      lightbox = null;
    };
  }, []);

  if (!data?.postGallery?.gallery?.nodes || !Array.isArray(data.postGallery.gallery.nodes)) {
    return null;
  }

  const nodes = data.postGallery.gallery.nodes;

  return (
    <div className="photoGallery px-0" id="photoGallery" style={{ width: '100%' }}>
      {nodes && (
        <>
          <div id="previousButton" className="swiper-button-prev px-0">
            <RectangleArrow />
          </div>
          <div id="nextButton" className="swiper-button-next px-0">
            <RectangleArrow />
          </div>

          <Swiper
            navigation={{
              prevEl: '.swiper-button-prev',
              nextEl: '.swiper-button-next',
            }}
            modules={[Navigation, Pagination]}
            spaceBetween={0}
            slidesPerView={1}
            pagination={{ clickable: true }}
            className="px-0"
          >
            {nodes.map((galleryItem, i) => {
              return (
                <SwiperSlide key={i} className="px-0">
                  <div className="galleryItem px-0" key={galleryItem.sourceUrl}>
                    <div className="galleryImage px-0">
                      <a
                        href={galleryItem.sourceUrl}
                        key={'photoGallery-' + i}
                        target="_blank"
                        rel="noreferrer"
                        className={clsx(addCanalPlusGTMClass(galleryItem.sourceUrl), 'px-0')}
                      >
                        <Image width={26} height={26} src={fullSize} className="fullSize" alt="full size icon" />
                        <Image
                          src={prepareImagePath(galleryItem.sourceUrl)}
                          alt={galleryItem.title}
                          title={galleryItem.title}
                          fill
                        />
                      </a>
                    </div>
                    <p className="imageTitle px-0">{galleryItem.title}</p>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </>
      )}
    </div>
  );
};

export default ACFPostGallery;
